module.exports = __webpack_public_path__ + "static/media/B1.16e02c32.png";